import { formatInTimeZone } from 'date-fns-tz';

import { DATE_FORMATTERS, TIME_ZONE } from '@/shared/consts';

export const transformDateToCorrectFormat = (date: string) =>
  formatInTimeZone(date, TIME_ZONE.MOSCOW, DATE_FORMATTERS.DAY_MONTH_FULL_YEAR_HOURS_MINUTES_SECONDS);
